import { render } from "./usereditor.vue?vue&type=template&id=3aa53580"
import script from "./usereditor.vue?vue&type=script&lang=js"
export * from "./usereditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__